module.exports = __webpack_public_path__ + "components/popular-cities-header/static/header--large-0824ea50be141f5a47a47186d7624888.jpg";